import * as React from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Bell as NotificationsRoundedIcon } from 'lucide-react';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../../theme/ColorModeIconDropdown';
import Search from './Search';

export default function Header({ currentView }: { currentView: string }) {
  const [selectedDate, setSelectedDate] = React.useState<string>(
    new Date().toISOString().split('T')[0]
  );
  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: { md: 'calc(100% - 240px)' },
        alignItems: 'center',
        justifyContent: 'space-between',
        pt: 1.5,
        pb: 1.5,
        px: 3,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)',
        position: 'fixed',
        top: 0,
        left: { md: '240px' },
        right: 0,
        zIndex: 1100,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs currentView={currentView} />
      <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
        <Search />
        <TextField
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          size="small"
          sx={{
            width: '200px',
            '& .MuiOutlinedInput-root': {
              fontSize: '0.875rem',
            }
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <MenuButton showBadge aria-label="Open notifications">
          <NotificationsRoundedIcon size={20} />
        </MenuButton>
        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
}
